import type { GameProductShort } from '@patrianna/shared-patrianna-types/store/GameModule'

import { PARLAY_ROOM_CODES_GC, PARLAY_ROOM_CODES_SC } from 'config/parlay-rooms-codes'
import BingoTile from 'containers/Bingo/BingoTile'
import { useAppSelector } from 'store/hooks'
import { getActiveCurrencyIdSelector } from 'store/modules/currencies/selectors'

import useGetBingoProducts from '../hooks/useGetBingoProducts'

export default function AllBingoRoomsContainer() {
  const bingoGames = useGetBingoProducts()
  const activeCurrency = useAppSelector(getActiveCurrencyIdSelector)
  const parlayRoomCodes = activeCurrency === 'SC' ? PARLAY_ROOM_CODES_SC : PARLAY_ROOM_CODES_GC

  const rooms = bingoGames.filter((item: GameProductShort) => parlayRoomCodes.includes(item.code))

  return (
    <div className='grid items-start gap-3 px-4 pb-4 grid-cols-2 lg:grid-cols-3' data-testid='bingo-rooms-container'>
      {rooms.map((room: GameProductShort) => (
        <BingoTile key={room.code} room={room} with3DImage hideFavorite />
      ))}
    </div>
  )
}
